import axios from "axios";
import {
  TransportQueryParams,
  TransportantionDistancePrice,
  TransportantionPromoIncreases,
  PromoIncrease,
} from "./transportationInterface";
export { transformationActions };

axios.defaults.withCredentials = true;

function transformationActions() {
  const baseUrl = ``;
  const tenantVal = `${process.env.REACT_APP_TENANT}`;
  return {
    getSupplier,
    getDistanceRouterPerPriceQueryParams,
    getDistancepriceQueryParams,
    getProvince,
    uploadPriceFile,
    downloadTemplate,
    uploadPriceList,
    downloadTemplateById,
    ChangePriceListsActivation,
    getPromoQueryParams,
    deletePriceIncrease,
    addPromoIncrease,
    editPromoIncrease,
    PriceListStatus
  };

  async function getSupplier(tenant:string|undefined) {
    return new Promise(function (resolve, reject) {
      axios
        .get(`${baseUrl}/masterdatatransportation/supplier/all`,{params:{tenant:tenant}})
        .then(function (brands) {
          resolve(brands);
        });
    });
  }

  async function getDistanceRouterPerPriceQueryParams(tenant:string|undefined,pageNumber:any,pageSize:any,
    idSupplier?:any,idProvinceStart?:any,idProvinceEnd?:any,dateTime?:any,

  ) {
    return axios.get(
      `${baseUrl}/masterdatatransportation/routeprice`,
      {
        params:{
          tenant:tenant,
          idProvinceStart:idProvinceStart,
          idProvinceEnd:idProvinceEnd,
          date:dateTime,
          idSupplier:idSupplier,
          pageNumber:pageNumber,
          pageSize:pageSize
        }
      }
    );
  }
  async function getProvince() {
    return new Promise(function (resolve, reject) {
      axios
        .get(`${baseUrl}/masterdatatransportation/province/all`)
        .then(function (carSegment) {
          resolve(carSegment);
        });
    });
  }

  /// ready not yet
  async function uploadPriceFile(
    pageNumber: number,
    pageSize: number,
    supplierId?: any,
    dateTime?: Date,
    idProvinceStart?: number,
    idProvinceEnd?: number
  ) {
    const params = {
      pageNumber: pageNumber,
      pageSize: pageSize,
      datetime: dateTime,
      idProvinceStart: idProvinceStart,
      idProvinceEnd: idProvinceEnd,
      supplierId: supplierId,
    };
    return axios.get(
      `${baseUrl}/masterdatatransportation/pricelistfileuploaded`,
      { params: params, responseType: "arraybuffer" }
    );
  }

  async function getDistancepriceQueryParams(tenant:string|undefined,pageNumber:any,pageSize:any,
    supplierId?:any, dateTime?:any,kms?:any
  ) {
    return axios.get(
      `${baseUrl}/masterdatatransportation/distanceprice`,
      {
        params: {
          tenant:tenant,
          date:dateTime,
          kms:kms,
          supplierId:supplierId,
          pageNumber:pageNumber,
          pageSize:pageSize
        }
      }
    );
  }

  async function downloadTemplate() {
    return axios.get(
      `${baseUrl}/masterdatatransportation/priceListFileUploaded/template`,
      { responseType: "arraybuffer" }
    );
  }

  async function uploadPriceList(tenant:string,id: number, fileName: FormData) {
    return axios.post(
      `${baseUrl}/masterdatatransportation/supplier/${id}`,
      fileName
      ,{params:{tenant:tenant}}
    );
  }

  async function downloadTemplateById(tenant:string, id: number) {
    return axios.get(
      `${baseUrl}/masterdatatransportation/pricelistfileuploaded/${id}/file`,
      { params: {tenant: tenant}, responseType: "arraybuffer" }
    );
  }

  async function ChangePriceListsActivation(
    tenant:string,
    supplierId: number,
    active: boolean
  ) {
    return axios.put(
      `${baseUrl}/masterdatatransportation/changepricelistsactivation/${supplierId}?tenant=${tenant}&active=${active}`
    );
  }

  async function getPromoQueryParams(tenant:string|undefined,pageNumber:any,pageSize:any,supplierId?:any,dateTime?:any) {
    return axios.get(
      `${baseUrl}/masterdatatransportation/priceincrease`,
      {
        params: {
          tenant:tenant,
          supplierId:supplierId,
          date:dateTime,
          pageNumber:pageNumber,
          pageSize:pageSize
        },
      }
    );
  }

  async function deletePriceIncrease(tenant:string,id: number) {
    return axios.delete(
      `${baseUrl}/masterdatatransportation/priceincrease/${id}`,{params:{tenant:tenant}}
    );
  }

 

  async function addPromoIncrease(tenant:string,addPromo:PromoIncrease) {
    return axios.post(
      `${baseUrl}/masterdatatransportation/priceincrease`,addPromo,{params:{tenant:tenant}}
    );
  }

  async function editPromoIncrease(tenant:string,id:number,addPromo:PromoIncrease) {
    return axios.put(
      `${baseUrl}/masterdatatransportation/priceincrease/${id}`,addPromo,{params:{tenant:tenant}}
    );
  }

  async function PriceListStatus(tenant:string,id:number){
    return axios.get(
      `${baseUrl}/masterdatatransportation/pricelistsactivationstatus/${id}`,{params:{tenant:tenant}}
    );
  }
}
